import { createSlice } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { getTotalSize, removeObject } from "../components/utilities";


const menuSlice = createSlice({
  name: "menu",
  initialState: {
    id: "",
    type: "post",
    active: false,
    display: true,
    parameter: false,
    activeItem: {},
    dynamicRoutes: [],
    activeAccordion:0,
    activeMenuItem:0,
    activeSubMenu:0,
  },
  reducers: {
    resetMenu: (state, action) => {
      return {
        id: "",
        type: "post",
        active: false,
        display: true,
        parameter: false,
        activeItem: {},
        dynamicRoutes: [],
        activeAccordion:0,
        activeMenuItem:0,
        activeSubMenu:0,
      };
    },
    toggleMenuDisplay: (state, action) => {
      const newItem = {
        id: action.payload.id,
        type: action.payload.type,
        active: true,
        display: true,
        firstChildID: action.payload.firstChildID,
        activeItem: action.payload.firstChild,
      };
      return newItem;
    },
    setActiveItem: (state, action) => {
      const newState = { ...state, activeItem: action.payload };
      return newState;
    },
    collapseMenuDisplay: (state, action) => {
      state.display = state.display ? false : true;
    },
    setParameter: (state, action) => {
      state.parameter = action.payload;
    },
    setActiveAccordion: (state, action) => {
      
      state.activeAccordion = action.payload;
    },
    setActiveMenu: (state, action) => {
      state.activeMenuItem = action.payload;
    },
    setActiveSubMenu: (state, action) => {
      state.activeSubMenu = action.payload;
    },
    setDynamicRoutes: (state, action) => {
      if (
        JSON.stringify(state.dynamicRoutes) !== JSON.stringify(action.payload)
      ) {
        return {
          ...state,
          dynamicRoutes: action.payload,
        };
      }
      return state;
    },
  },
});

const userSlice = createSlice({
  name: "user",
  initialState: {
    isLoggedIn: sessionStorage.getItem("isLoggedIn")
      ? sessionStorage.getItem("isLoggedIn")
      : false,
    user: {},
    sessionActive: false, 
    firstTimeLogin: false,
    userID: 0,
    userGroupID: 0,
    countries: [],
    hotels: [],
    markets: [],
    userTypes: [],
    docCategories: [],
    seasons: [],
  },
  reducers: {
    resetUser: (state, action) => {
      return {
        isLoggedIn: false,
        sessionActive: false,
        user: {},
        firstTimeLogin: false,
        userID: 0,
        userGroupID: 0,
        countries: [],
        hotels: [],
        markets: [],
        userTypes: [],
        docCategories: [],
        seasons: [],
      };
    },
    signIn: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      state.isLoggedIn = true;
      state.sessionActive = true;
      state.userID = action.payload.userID;
      state.userGroupID = action.payload.userGroupID;
    },
    signOut: (state) => {
      state.user = {};
      state.isLoggedIn = false;
      state.sessionActive = false;
      sessionStorage.clear();
      localStorage.clear();
    },
    setSession: (state, action) => {
      state.sessionActive = action.payload;
     
    },
    storeCountries: (state, action) => {
      if (action.payload.status === 200) {
        state.countries = action.payload.result;
      }
    },
    storeUserTypes: (state, action) => {
      if (action.payload.status === 200) {
        state.userTypes = action.payload.result;
      }
    },
    storeHotels: (state, action) => {
      state.hotels = action.payload;
    },
    storeMarkets: (state, action) => {
      if (action.payload.status === 200) {
        state.markets = action.payload.result;
      }
    },
    storeDocCategories: (state, action) => {
      state.docCategories = action.payload;
    },
    storeSeasonality: (state, action) => {
      state.seasons = action.payload;
    },
  },
});

const appStateSlice = createSlice({
  name: "appState",
  initialState: {
    weddingForm: {},
    latestDocuments: [],
    unread_nb: 0,
  },
  reducers: {
    setWedForm: (state, action) => {
      state.weddingForm = action.payload;
    },
    setLatestDocument: (state, action) => {
     
      state.latestDocuments = action.payload.data;
      state.unread_nb = action.payload.new_doc_nb;
    },
    resetApp: (state, action) => {
      return {
        weddingForm: {},
        latestDocuments: [],
        unread_nb: 0,
      };
    },
  },
});

const cartSlice = createSlice({
  name: "cart",
  initialState: { counter: 0, cart: [], totalSize: 0, isDownloading:false },
  reducers: {
    addCart: (state, action) => {
     
      const newItem = {
        ...action.payload, 
        // id: state.cart.length,
      };
    
      state.cart.push(newItem);
      state.counter = state.cart.length;
      state.totalSize = getTotalSize(state.cart);
    },
    removeCart(state, action) {
      const newCart = removeObject(state.cart, action.payload);
      state.cart = newCart;
      state.counter = newCart.length;
      state.totalSize = getTotalSize(state.cart);
    },
    clearCart(state) {
      state.cart = [];
      state.counter = 0;
      state.totalSize = getTotalSize(state.cart);
    },
    isDownloading(state, action) {
      state.isDownloading = action.payload;
    },
  },
});

export const rootReducer = combineReducers({
  user: userSlice.reducer,
  menu: menuSlice.reducer,
  cart: cartSlice.reducer,
  appState: appStateSlice.reducer,
});

export const {
  signIn,
  signOut,
  storeCountries,
  storeUserTypes,
  storeHotels,
  storeMarkets,
  storeDocCategories,
  storeSeasonality,
  resetUser,
  setSession
} = userSlice.actions;
export const {
  toggleMenuDisplay,
  collapseMenuDisplay,
  setParameter,
  setActiveItem,
  setDynamicRoutes,
  resetMenu,
  setActiveAccordion,
  setActiveMenu,
  setActiveSubMenu,
  
} = menuSlice.actions;
export const { removeCart, addCart, clearCart ,isDownloading} = cartSlice.actions;
export const {
  setWedForm,
  setLatestDocument,
  resetApp,
} = appStateSlice.actions;
export default rootReducer;
